import styled from "styled-components";
import { CssRule } from "../../../themes/architecture/css-helpers/css-rule";
import { UserMenuSectionBox } from "../../user-menu/user-menu/boxes/user-menu-section.box";

export const LoyaltyBarSectionBox = styled(UserMenuSectionBox)`
    position: relative;
    display: block;
    ${CssRule.For.mobile.build()} &{
        margin: 1rem 0;
    }
`;
